import { createFileRoute } from '@tanstack/react-router';
import { TenantRolesTabs } from '../../components/tenant/TenantRolesTabs';

export const Route = createFileRoute('/_authenticated/_layout/tenant/roles/')({
    component: () => <TenantRolesTabs />,
});
